import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { IAppState } from '@shared/models';
import { AppRoutesEnum } from '@shared/enums';
import { getIsDebtAdvisor } from '@features/auth/state/selectors';
import { waitUntilUserInitialized } from '@features/auth/utils';

@Injectable({
  providedIn: 'root',
})
export class NotDebtAdvisorUserGuard {
  constructor(private store$: Store<IAppState>, private router: Router) {}

  public canActivate(): Observable<boolean> {
    return this.store$.pipe(waitUntilUserInitialized(this.store$), select(getIsDebtAdvisor)).pipe(
      take(1),
      map((isDebtAdvisor) => {
        if (isDebtAdvisor) {
          this.router.navigate([AppRoutesEnum.DEFAULT]);
          return false;
        }

        return true;
      })
    );
  }
}

export const canActivateNotDebtAdvisorUser: CanActivateFn = () => inject(NotDebtAdvisorUserGuard).canActivate();
